import React from 'react';
import { PageLevelMessage } from '@americanexpress/dls-react';
import parse from "html-react-parser";

function Error({ errorList }) {

    return (
        <div>
            {errorList && (<PageLevelMessage
                type="warning" 
                dismissible={false} autoFocus
            >
                Errors:
                <ul>{errorList.map(error => (
                    <li key={error}>{parse(error)}</li>
                ))}
                </ul>
            </PageLevelMessage>)}
        </div>

    );
}

export default Error;